import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  FormControl,
} from '@material-ui/core';

import EventDataForm from '../../pages/EventDataSettings/components/EventDataForm';
import { getEventDataValidationText } from '../../../utils/eventDataHelper';
import styles from './styles';

export const getDefaultStateForProps = (selectedEventData = {}, eventData = {}) => {
  const newSelectedEventData = [];
  Object.keys(selectedEventData || {}).forEach((key) => {
    const foundEventData = eventData.filter((ed) => ed.name === key);
    if (foundEventData.length >= 1) {
      const newEventData = foundEventData[0];
      newEventData.value = selectedEventData[key].value;
      newSelectedEventData.push(newEventData);
    }
  });
  return {
    updatedEventData: newSelectedEventData,
    eventDataInputValue: '',
  };
};

const checkEventDataValid = (eventData) => {
  const updatedEventData = eventData;
  for (let i = 0; i < updatedEventData.length; i += 1) {
    const isValidResponse = getEventDataValidationText(updatedEventData[i], updatedEventData[i].required);
    updatedEventData[i].error = !!isValidResponse;
    updatedEventData[i].helperText = isValidResponse;
  }

  return updatedEventData;
};

export class EditEventDataComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = getDefaultStateForProps(props.selectedEventData, props.eventData);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedEventData
       && prevProps.selectedEventData !== this.props.selectedEventData) {
      this.setState(getDefaultStateForProps(this.props.selectedEventData, this.props.eventData));
    }
  }

  handleUpdatedEventDataInput = (inputVal) => {
    this.setState({ eventDataInputValue: inputVal || '' });
  }

  handleUpdatedEventData = (updatedEventData) => {
    this.setState({ updatedEventData: checkEventDataValid(updatedEventData) }, () => {
      const formattedEventData = {};
      for (let i = 0; i < this.state.updatedEventData.length; i += 1) {
        formattedEventData[this.state.updatedEventData[i].name] = {
          error: this.state.updatedEventData[i].error,
          type: this.state.updatedEventData[i].type,
          value: this.state.updatedEventData[i].value
            ? this.state.updatedEventData[i].value
            : '',
        };
      }
      this.props.onUpdate(formattedEventData);
    });
  }

  render() {
    const {
      classes,
      eventData,
    } = this.props;
    const {
      eventDataInputValue,
      updatedEventData,
    } = this.state;

    return (
      <FormControl
        className={classes.container}
        fullWidth
        variant="outlined"
      >
        <EventDataForm
          allEventData={eventData}
          selectedEventData={updatedEventData}
          eventDataInputValue={eventDataInputValue}
          handleUpdatedEventData={this.handleUpdatedEventData}
          handleUpdatedEventDataInput={this.handleUpdatedEventDataInput}
          showEventDataSelector
        />
      </FormControl>
    );
  }
}

EditEventDataComponent.propTypes = {
  classes: PropTypes.object,
  onUpdate: PropTypes.func,
  eventData: PropTypes.array,
  selectedEventData: PropTypes.object,
};

EditEventDataComponent.defaultProps = {
  classes: {},
  onUpdate: () => {},
  eventData: [],
  selectedEventData: {},
};

export default (withStyles(styles, { withTheme: true })(EditEventDataComponent));
